module.exports = __webpack_public_path__ + "static/carousel7-f05e36a3b635316324cc23d5c025ed43.jpg";